export default "__VITE_ASSET__e6361795__"